import React from "react";
import { PLAY_STORE_URL } from "@/lib/constants";

export const PlayBadge = ({ testId, variant = "dark", className = "" }) => {
  const dark = variant === "dark";
  return (
    <a
      href={PLAY_STORE_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testId}
      className={`group inline-flex items-center gap-3 rounded-2xl border px-5 py-3 transition-all duration-300 ${
        dark
          ? "bg-[#0A0A0A] border-[#0A0A0A] text-white hover:bg-[#1a1a1a]"
          : "bg-white border-[#E5E5E0] text-[#0A0A0A] hover:border-[#0A0A0A]"
      } ${className}`}
    >
      <svg
        viewBox="0 0 512 512"
        className="h-7 w-7 shrink-0"
        aria-hidden="true"
      >
        <path
          d="M325.3 234.3L104.6 13l280.8 161.2-60.1 60.1zM47 0C34 6.8 25.3 19.2 25.3 35.3v441.3c0 16.1 8.7 28.5 21.7 35.3l256.6-256L47 0zm425.2 225.6l-58.9-34.1-65.7 64.5 65.7 64.5 60.1-34.1c18-14.3 18-46.5-1.2-60.8zM104.6 499l280.8-161.2-60.1-60.1L104.6 499z"
          fill="currentColor"
        />
      </svg>
      <div className="flex flex-col items-start leading-none">
        <span className="text-[10px] uppercase tracking-[0.18em] opacity-70">
          GET IT ON
        </span>
        <span className="font-semibold text-base mt-1">Google Play</span>
      </div>
    </a>
  );
};
